// extracted by mini-css-extract-plugin
module.exports = {"Scrollbar":"Scrollbar_Scrollbar__1G764","Scrollbar_Content":"Scrollbar_Scrollbar_Content__1giuq"};